module.exports = __webpack_public_path__ + "img/img8.27cc4a0f.png";